"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const reactstrap_1 = require("reactstrap");
const useSendCampaign_1 = require("./useSendCampaign");
const useSendCampaignTest_1 = require("./useSendCampaignTest");
const hooks_1 = require("../../../../../hooks");
const PreviewModal_1 = require("../../../../../comps/reusables/PreviewModal");
const react_use_1 = require("react-use");
const react_if_1 = require("react-if");
exports.SendTestEmailButton = (props) => {
    const { featureFlags: { useNewLightweightSendCampaignMutationForTestCampaigns }, } = hooks_1.useOsmosysContext();
    if (useNewLightweightSendCampaignMutationForTestCampaigns) {
        return react_1.default.createElement(exports.SendTestEmailButtonNew, Object.assign({}, props));
    }
    return react_1.default.createElement(exports.SendTestEmailButtonOld, Object.assign({}, props));
};
exports.SendTestEmailButtonNew = ({ activeStep, data, disabled, error, onSendOrSkip, }) => {
    const { sendCampaign, sendCampaignResult } = useSendCampaign_1.useSendCampaign({
        onCompleted: res => {
            onSendOrSkip(res.sendCampaign);
        },
        variables: {
            data: {
                emailId: data.emailId,
                subjectLines: data.subjectLines,
                test: true,
            },
        },
    });
    return (react_1.default.createElement(exports.SendTestEmailButtonCore, { activeStep: activeStep, disabled: disabled, error: error, mutate: sendCampaign, onSendOrSkip: onSendOrSkip, mutationResult: sendCampaignResult, html: data.html }));
};
exports.SendTestEmailButtonOld = ({ activeStep, data, disabled, error, onSendOrSkip, }) => {
    const { sendTestCampaign, sendTestCampaignResult } = useSendCampaignTest_1.useSendCampaignTest({
        onCompleted: res => {
            onSendOrSkip(res.espSendCampaignTest);
        },
        variables: {
            data,
        },
    });
    return (react_1.default.createElement(exports.SendTestEmailButtonCore, { activeStep: activeStep, disabled: disabled, error: error, mutate: sendTestCampaign, onSendOrSkip: onSendOrSkip, mutationResult: sendTestCampaignResult, html: data.html }));
};
exports.SendTestEmailButtonCore = ({ activeStep, disabled, error, onSendOrSkip, mutationResult, mutate, html, }) => {
    const [showPreview, togglePreview] = react_use_1.useToggle(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
            react_1.default.createElement(react_2.OsmosysDiv, null,
                react_1.default.createElement(react_2.OsmosysButton, { osysName: "SendTestEmailButton", color: "primary", className: "mt-2", disabled: !!error || activeStep <= 1, mutate: mutate, outline: activeStep !== 2, mutationResult: mutationResult, osysIcon: "arrowRight", iconPosition: "right" }, "Send test email")),
            react_1.default.createElement(react_if_1.When, { condition: false },
                react_1.default.createElement(react_2.OsmosysDiv, null,
                    react_1.default.createElement(react_2.OsmosysButton, { osysName: "Show preview", osysIcon: "show", tooltip: "Show preview", onClick: togglePreview, className: "ml-2" }),
                    react_1.default.createElement(PreviewModal_1.PreviewModal, { html: html, isOpen: showPreview, onClose: togglePreview })))),
        react_1.default.createElement(reactstrap_1.FormText, { className: "" },
            react_1.default.createElement("a", { className: "text-reset", href: "#", onClick: e => {
                    if (disabled) {
                        return;
                    }
                    e.preventDefault();
                    onSendOrSkip(true);
                } }, disabled ? 'Waiting for subject line to save...' : 'Skip'))));
};
//# sourceMappingURL=SendTestEmailButton.js.map